export default "__VITE_ASSET__0dde9016__"